var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticaliconDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66683 8C3.66683 8.92047 2.92064 9.66667 2.00016 9.66667C1.07969 9.66667 0.333496 8.92047 0.333496 8C0.333496 7.07953 1.07969 6.33333 2.00016 6.33333C2.92064 6.33333 3.66683 7.07953 3.66683 8Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66683 2.16667C3.66683 3.08714 2.92064 3.83333 2.00016 3.83333C1.07969 3.83333 0.333496 3.08714 0.333496 2.16667C0.333496 1.24619 1.07969 0.5 2.00016 0.5C2.92064 0.5 3.66683 1.24619 3.66683 2.16667Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66683 13.8333C3.66683 14.7538 2.92064 15.5 2.00016 15.5C1.07969 15.5 0.333496 14.7538 0.333496 13.8333C0.333496 12.9129 1.07969 12.1667 2.00016 12.1667C2.92064 12.1667 3.66683 12.9129 3.66683 13.8333Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticaliconDots);
export default __webpack_public_path__ + "static/media/verticalicon-dots.c51618f25d8dce49e0b27d6f7631b5a0.svg";
export { ForwardRef as ReactComponent };